export default "__VITE_ASSET__08c3b1fa__"